import { Box, Heading, Text } from "@chakra-ui/react";

import { ICallout } from "../../../../../utils/types";

import styles from "./GuideContentBody.module.scss";

interface CalloutContentProps {
  field: ICallout;
}

export default function CalloutContent({ field }: CalloutContentProps) {
  return (
    <Box
      className={styles.callout}
      {...field.styles?.container}
      data-testid="callout"
    >
      <Heading {...field.styles?.heading} color="gray.800">
        {field.title}
      </Heading>
      <Text {...field.styles?.text} color="gray.600">
        {field.content}
      </Text>
    </Box>
  );
}
